// Breakpoints
const tabletBreakPoint = 1024;
const mobileBreakPoint = 620;

// Elements
const tabSection = document.querySelector('.pdp-tabs-v3');
const skuSpan = document.getElementById('variant-sku');
const barcodeSpan = document.getElementById('variant-barcode');
const tabsList = document.querySelectorAll('.tab-item');
const tabIcons = document.querySelectorAll('.tab-icon');
const variantImages = document.querySelectorAll('.variant-image');
const readMoreBtns = document.querySelectorAll('.read-more-btn');

const hamburgerBtn = document.querySelector('.product-v3 .hamburger-btn');
const hamburgerIcon = document.querySelectorAll('.product-v3 .hamburger-btn .bars-solid');
const menuCloseIcon = document.querySelectorAll('.product-v3 .hamburger-btn .close-solid');
const navBuyNowBtn = document.querySelector('.pdp-breadcrumb-submenu-v3 .buy-now-btn');
const navAddToCartContainer = document.querySelector('.pdp-breadcrumb-submenu-v3 .nav-add-to-cart');
const navLinksWrapper = document.querySelector('.pdp-breadcrumb-submenu-v3 .nav-links-wrapper');
const navCloseIcon = document.querySelector('.pdp-breadcrumb-submenu-v3 .xmark-solid');
const btnTextSpan = document.querySelector('.pdp-breadcrumb-submenu-v3 .buy-now-btn .btn-text-span');

////////////////////////////////////
//pdp-gallery-v3.js
////////////////////////////////////

// Vimeo Thumbnail Fetching and Modal Handling
document.querySelectorAll('.rr-video-thumbnail-container').forEach(container => {
    const vimeoUrl = container.getAttribute('data-vimeo-url');
    if (!vimeoUrl) return;

    const apiUrl = `https://vimeo.com/api/oembed.json?url=https://vimeo.com/${vimeoUrl}`;

    fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
            const img = document.createElement('img');
            img.src = data.thumbnail_url;
            img.alt = data.title || 'Vimeo thumbnail';
            img.classList.add('rr-video-thumbnail');
            container.appendChild(img);
        })
        .catch(console.error);
    }
);

//Video Title Fetching
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.video-title-v3').forEach(async (el) => {
        const videoId = el.getAttribute('data-vimeo-url');
        if (!videoId) return;

        try {
        const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
        const data = await response.json();

        if (data && data.title) {
            el.textContent = data.title;
        } else {
            el.textContent = 'Untitled video';
        }
        } catch (error) {
        console.error(`Error fetching Vimeo title for ${videoId}:`, error);
        el.textContent = 'Video unavailable';
        }
    });
});

//Gallery Video Stop Playing Script
document.addEventListener('click', event => {
    const trigger = event.target.closest('.gallery-overlay button, .gallery-overlay li');

    if (!trigger) return;

    const galleryModal = trigger.closest('.gallery-overlay');

    galleryModal?.querySelectorAll('iframe').forEach(iframe => {
        iframe.contentWindow.postMessage('{"method":"pause"}', '*');
    });
});

const modal = document.querySelector('.popout-overlay');
const popOut = document.querySelector('.popout-container');

popOut.addEventListener('click', e => e.stopPropagation());

document.querySelectorAll('.popout-toggle').forEach(button => {
    button.addEventListener('click', function () {
        const contentContainerId = button.dataset.metafieldKey;
        const contentContainer = document.querySelector('.asset-container.' + contentContainerId);
        const popOutCloseBtn = document.querySelector('.popout-toggle.' + contentContainerId);

        if (contentContainerId) {
            contentContainer.classList.toggle('active');
            popOutCloseBtn.classList.toggle('active');
        }

        if (modal.style.display === 'flex') {
            modal.style.display = 'none';
            document.body.classList.remove('modal-open');
            popOut.classList.remove('active');
        } else {
            modal.style.display = 'flex';
            document.body.classList.add('modal-open');
             setTimeout(() => {
                popOut.classList.add('active');
            }, 300);
        }
    });
});

modal.addEventListener('click', () => {
    const activeCloseBtn = document.querySelector('.close-button.active');

    if (activeCloseBtn) {
        const key = activeCloseBtn.dataset.metafieldKey;
        const contentContainer = document.querySelector('.asset-container.' + key);
        const popOutCloseBtn = document.querySelector('.popout-toggle.' + key);

        modal.style.display = 'none';
        contentContainer.classList.remove('active');
        popOutCloseBtn.classList.remove('active');
        popOut.classList.remove('active');

        document.body.classList.remove('modal-open');
    }
})
/*
const nav = document.querySelector('.product-v3 .nav-links-wrapper');

window.addEventListener('resize', () => {
    if (window.innerWidth > 1600) {
        nav.classList.remove('active');
    }
});
*/

hamburgerBtn.addEventListener('click', () => {
    if (window.innerWidth < 1600) {
        navLinksWrapper.classList.toggle('active');
        navAddToCartContainer.classList.remove('active');
        navBuyNowBtn.classList.remove('active');
        navCloseIcon.classList.remove('active');
        btnTextSpan.classList.add('active');
        hamburgerIcon.forEach(icon => {icon.classList.toggle('active')});
        menuCloseIcon.forEach(icon => {icon.classList.toggle('active')});
    }
});

if (navBuyNowBtn) {
    navBuyNowBtn.addEventListener('click', () => {
        navBuyNowBtn.classList.toggle('active');
        navCloseIcon.classList.toggle('active');
        btnTextSpan.classList.toggle('active');
        hamburgerIcon.forEach(icon => {icon.classList.add('active')});
        menuCloseIcon.forEach(icon => {icon.classList.remove('active')});

        const wrapperIsActive = navLinksWrapper.classList.contains('active');

        if (window.innerWidth > 1600) {
            if (wrapperIsActive) {
                navLinksWrapper.classList.remove('active');
                setTimeout(() => navAddToCartContainer.classList.add('active'), 300);
            } else {
                navAddToCartContainer.classList.remove('active');
                setTimeout(() => navLinksWrapper.classList.add('active'), 300);
            }
        } else {
            navAddToCartContainer.classList.toggle('active');
            navLinksWrapper.classList.add('active');
        }
    });
}

//ZOOM POPUP
const windowWidth = window.innerWidth;
const windowHeight = window.innerHeight;

// Only enable zoom popup on desktop / landscape
if (windowWidth > windowHeight) {
    const zoomPopup = document.querySelector(".zoom-popup");
    const images = document.querySelectorAll(".main-image li img");

    images.forEach(img => {
        img.addEventListener("mouseenter", () => {
            zoomPopup.style.display = "block";
            zoomPopup.style.backgroundImage = `url(${img.src})`;
        });

        img.addEventListener("mouseleave", () => {
            zoomPopup.style.display = "none";
        });

        img.addEventListener("mousemove", (e) => {
            const rect = img.getBoundingClientRect();
            const x = e.clientX - rect.left;
            const y = e.clientY - rect.top;

            const zoomFactor = 3;
            const bgWidth = img.offsetWidth * zoomFactor;
            const bgHeight = img.offsetHeight * zoomFactor;

            let bgX = x * zoomFactor - zoomPopup.offsetWidth / 3;
            let bgY = y * zoomFactor - zoomPopup.offsetHeight / 3;

            bgX = Math.max(0, Math.min(bgX, bgWidth - zoomPopup.offsetWidth));
            bgY = Math.max(0, Math.min(bgY, bgHeight - zoomPopup.offsetHeight));

            zoomPopup.style.backgroundImage = `url(${img.src})`;
            zoomPopup.style.backgroundSize = `${bgWidth}px ${bgHeight}px`;
            zoomPopup.style.backgroundPosition = `-${bgX}px -${bgY}px`;
        });
    });
}

////////////////////////////////////
//pdp-variant-selector-v3
////////////////////////////////////

//VARIANT SELECTOR ELEMENT UPDATER
const itemPriceContainer = document.querySelectorAll('.item-price-v3-rebrand');
const priceSpans = document.querySelectorAll('.product-price-v3');
const comparePriceSpans = document.querySelectorAll('.compare-at-price-v3');
const savedTextSpans = document.querySelectorAll('.product-save-text-v3');
const saveText = window.translations.save;
const savedAmountSpans = document.querySelectorAll('.product-saving');
const savingsContainers = document.querySelectorAll('.price-saving-container-v3-rebrand');
const exVatPriceContainer = document.getElementById('ex-vat-container-v3');
const exVatPriceSpan = document.getElementById('exvat-amount-v3');
const klarnaPriceSpan = document.getElementById('product-klarna-price-v3');
const iwocaPriceSpan = document.getElementById('product-iwoca-price-v3');
const variantSelectorBtns = document.querySelectorAll('.variant-selector-btn');
const variantSelectorSelect = document.querySelectorAll('.variant-selector-select');
const formInputVariantIds = document.querySelectorAll('.product-add-to-cart-form-v3 input[name="id"]');
const variantTitles = document.querySelectorAll('.variant-title');
const evoPointsSpan = document.getElementById('total-points-span');

//QUANTITY INPUT INCREASE?DECREASE BUTTON HANDLER
document.addEventListener('click', event => {
  const btn = event.target.closest('.quantity-selector button');

  if (!btn) return;

  event.preventDefault();
  event.stopImmediatePropagation();

  const clickedInput = btn
    .closest('.quantity-selector')
    .querySelector('.quantity-input');

  if (!clickedInput) return;

  let currentValue = parseInt(clickedInput.value, 10) || 1;

  if (btn.textContent.trim() === '+') {
    currentValue += 1;
  } else {
    currentValue -= 1;
  }

  currentValue = Math.max(1, currentValue);

  document.querySelectorAll('.quantity-input').forEach(input => {
    input.value = currentValue;
  });
}, true);

function updateAddToCartState(variantTitleData, variantAvailable, variantIdData) {
    const addToCartStateContainers = document.querySelectorAll('.add-to-cart-state-v3');

    addToCartStateContainers.forEach(container => {
        container.innerHTML = `
            ${variantAvailable ? `
                <div class="quantity-selector current-product">
                    <button type="button" class="minus-button">-</button>
                    <input 
                        type="number" 
                        class="quantity-input" 
                        name="quantity" 
                        value="1" 
                        min="1"
                    >
                    <button type="button" class="plus-button">+</button>
                </div>

                {% if product.tags contains settings.preorder_tag %}
                    <button type="button" class="add-to-cart" id="add-to-cart-button">
                        <b>
                            {% render 'icon-library', id: 'box-circle-check-regular' %}
                            {{ settings.preorder_button }}
                        </b>
                    </button>
                {% else %}
                    <button type="submit" class="btn add-to-cart" id="add-to-cart-button">
                        <b>
                            {% render 'icon-library', id: 'cart-shopping-regular' %}
                            {{ 'product.buttons.add_to_cart' | t }}
                        </b>
                        ${(variantTitleData !== 'Default Title' && variantTitleData !== 'Default') ? `
                            <span id="selected-variant-title-v3" class="variant-title">${variantTitleData}</span>
                        ` : ''}
                    </button>
                {% endif %}
            ` : `
                {% if product.tags contains settings.preorder_tag %}
                    <button type="submit" class="btn add-to-cart" id="add-to-cart-button">
                        <b>
                            {% render 'icon-library', id: 'cart-shopping-regular' %}
                            {{ settings.preorder_button }}
                        </b>
                        ${(variantTitleData !== 'Default Title' && variantTitleData !== 'Default') ? `
                            <span id="selected-variant-title-v3" class="variant-title">${variantTitleData}</span>
                        ` : ''}
                    </button>
                {% else %}
                    {% if settings.out_of_stock_button == "bis_app" %}
                        <button class="bis-app-trigger" id="BIS_trigger" type="button">
                            <b>
                                {% render 'icon-library', id: 'bell-regular'%}
                                {{ 'product.buttons.get_notified' | t }}
                            </b>
                        </button>
                    {% else %}
                        <a class="klaviyo-bis-trigger" href="#">
                            <b>
                                {{ back_in_stock_message }}
                            </b><br>
                            <b>
                                {% render 'icon-library', id: 'bell-regular'%}
                                {{ 'product.buttons.get_notified' | t }}
                            </b>
                        </a>
                    {% endif %}
                {% endif %}
            `}
        `;
    });

    document.querySelectorAll('.product-add-to-cart-form-v3 input[name="id"]').forEach(input => {
        input.value = variantIdData;
    });
}

variantSelectorBtns.forEach(button => {
    button.addEventListener('click', function() {
        const thumbnailImageList = document.querySelectorAll('.thumbnail-images li');
        const variantIdData = button.getAttribute('data-id');
        const variantTitleData = button.getAttribute('data-title');
        const priceData = button.getAttribute('data-price');
        const evoPoints = button.getAttribute('data-evo-points');
        const comparePriceData = button.getAttribute('data-compare-price'); 
        const savedAmountData = button.getAttribute('data-saved-amount');
        const exVatPriceData = button.getAttribute('data-ext-vat-price');
        const klarnaPriceData = button.getAttribute('data-klarna-price');
        const iwocaPriceData = button.getAttribute('data-iwoca-price');
        const imageUrl = button.getAttribute('data-featured-image-url');
        const variantAvailable = button.getAttribute('data-available') === 'true';

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantIdData);
        history.replaceState(null, '', url);

        variantSelectorSelect.forEach(select => {
            const matchingOption = [...select.options].find(
                option => option.dataset.id === variantIdData
            );

            if (matchingOption) {
                matchingOption.selected = true;
                select.dispatchEvent(new Event('change'));
            }
        });

        if (priceSpans.length > 0) {
            priceSpans.forEach(span => {
                span.textContent = priceData;
            });
        }

        if (comparePriceSpans.length > 0) {
            comparePriceSpans.forEach(span => {
                span.textContent = comparePriceData;
            });
        }

        if (formInputVariantIds.length > 0) {
            formInputVariantIds.forEach(input => {
                input.value = variantIdData;
            });
        }

        if (variantTitles.length > 0) {
            variantTitles.forEach(e => {
                e.textContent = variantTitleData;
            });
        }

        updateAddToCartState(variantTitleData, variantAvailable, variantIdData);

        if (exVatPriceSpan) { 
            exVatPriceSpan.textContent = exVatPriceData; 
        }

        const savedAmountNumber = Number(
            savedAmountData.replace(/[^0-9.-]/g, '')
        );

        if (savedAmountData.includes('-') || savedAmountNumber === 0) {
            savingsContainers.forEach(e => {e.classList.remove('active')});
            itemPriceContainer.forEach(e => {e.classList.remove('saving')});
            comparePriceSpans.forEach(e => {e.textContent = '';});
        } else {
            savingsContainers.forEach(e => {e.classList.add('active')});
            itemPriceContainer.forEach(e => {e.classList.add('saving')});
            comparePriceSpans.forEach(e => {e.textContent = comparePriceData;});
        }

        if (savedAmountSpans.length > 0) {
            savedTextSpans.forEach(e => {e.textContent = saveText;});
            savedAmountSpans.forEach(e => {e.textContent = savedAmountData;});
        }

        if (klarnaPriceSpan) {
            klarnaPriceSpan.textContent = klarnaPriceData;
        }

        if (iwocaPriceSpan) {
            iwocaPriceSpan.textContent = iwocaPriceData;
        }

        if (evoPointsSpan) {
            evoPointsSpan.textContent = evoPoints;
        }

        skuSpan && (skuSpan.textContent = button.dataset.sku);
        barcodeSpan && (barcodeSpan.textContent = button.dataset.barcode);
        

        if (imageUrl) {
            updateAcvitveImage(imageUrl);
            ensureActiveOverlayThumbVisible();
        }

        if (variantImages.length > 0) {
            variantImages.forEach(image => {
                image.src = imageUrl;
            })
        }

        variantSelectorBtns.forEach(btn => {
            const checkmarkContainer = btn.querySelector('.checkmark-container');
            btn.classList.remove('active')
            if (checkmarkContainer) checkmarkContainer.classList.remove('active-checkmark');
        });
        
        button.classList.add('active');
        const checkmarkContainer = button.querySelector('.checkmark-container');
        if (checkmarkContainer) checkmarkContainer.classList.add('active-checkmark');
    })
});

variantSelectorSelect.forEach(select => {
    select.addEventListener('change', () => {
        const selectedVariant = select.options[select.selectedIndex];
        const selectedVariantId = selectedVariant.dataset.id;
        const matchingButton = Array.from(variantSelectorBtns).find(btn => btn.dataset.id === selectedVariantId);
        matchingButton.click();
    })
});

/*
document.addEventListener('DOMContentLoaded', () => {
  try {
    const params = new URLSearchParams(window.location.search);
    let variantIdFromUrl = params.get('variant');

    if (!variantIdFromUrl) {
      const pathMatch = window.location.pathname.match(/\/(\d+)$/);
      if (pathMatch) variantIdFromUrl = pathMatch[1];
    }

    let targetBtn = null;

    if (variantIdFromUrl) {
      targetBtn = Array.from(document.querySelectorAll('.variant-selector-btn'))
        .find(btn => btn.getAttribute('data-id') === String(variantIdFromUrl));
    }

    if (!targetBtn) {
      targetBtn = document.querySelector('.variant-selector-btn.active');
    }

    if (!targetBtn) {
      targetBtn = Array.from(document.querySelectorAll('.variant-selector-btn'))
        .find(btn => btn.getAttribute('data-available') === 'true');
    }

    if (targetBtn) {
      targetBtn.click();

      const targetVariantId = targetBtn.getAttribute('data-id');

      const url = new URL(window.location.href);
      url.searchParams.set('variant', targetVariantId);
      history.replaceState(null, '', url);
    }
  } catch (e) {
    console.error('Variant preselect error:', e);
  }
});
*/

/*
//QUANTITY INPUT INCREASE?DECREASE BUTTON HANDLER
document.querySelectorAll('.quantity-selector button').forEach(function (btn) {
    btn.addEventListener('click', function () {
        const quantityWrapper = btn.closest('.quantity-selector');
        const quantityInput = quantityWrapper.querySelector('input[type="number"]');

        if (!quantityInput) return;

        let currentValue = parseInt(quantityInput.value, 10) || 1;

        if (btn.textContent.trim() === '+') {
            quantityInput.value = currentValue + 1;
        } else if (btn.textContent.trim() === '-') {
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
            }
        }
    });
});*/

////////////////////////////////////
// OVERFLOW BORDER HELPER
////////////////////////////////////
function updateOverflowBorders(root = document) {
  const targets = root.querySelectorAll
    ? root.querySelectorAll('.overflow-border')
    : []; // root may be an element or document

  targets.forEach(el => {
    const isOverflowing = el.scrollWidth > el.clientWidth;
    el.classList.toggle('active', isOverflowing);
  });
}

// Optional: keep them updated if their size/content changes
function attachResizeObservers() {
  if (!('ResizeObserver' in window)) return;
  const ro = new ResizeObserver(entries => {
    for (const { target } of entries) {
      const isOverflowing = target.scrollWidth > target.clientWidth;
      target.classList.toggle('active', isOverflowing);
    }
  });
  document.querySelectorAll('.overflow-border').forEach(el => ro.observe(el));
}

////////////////////////////////////
// LAZY LOAD FOR OFF-SCREEN IMAGES
// + SECTION REVEAL ON SCROLL
////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const lazyImages   = document.querySelectorAll('img[data-src]');
  const lazySections = document.querySelectorAll('.lazy-section');
  const lazyIframes  = document.querySelectorAll('iframe[data-src]');

  // Initial check (in case some are already present)
  updateOverflowBorders();
  attachResizeObservers();

  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      const target = entry.target;

      // Handle images
      if (target.tagName === 'IMG' && target.dataset.src) {
        target.src = target.dataset.src;
        target.removeAttribute('data-src');
        target.onload = () => {
          target.classList.add('loaded');
          // After the image paints, re-check any overflow containers in the same section / DOM
          requestAnimationFrame(() => updateOverflowBorders(document));
        };
      }

      // Handle iframes (YouTube/Vimeo/etc)
      if (target.tagName === 'IFRAME' && target.dataset.src) {
        target.src = target.dataset.src;
        target.removeAttribute('data-src');
        target.addEventListener('load', () => {
          target.classList.add('loaded');
          requestAnimationFrame(() => updateOverflowBorders(document));
        });
      }

      // Handle sections
      if (target.classList.contains('lazy-section')) {
        target.classList.add('section-visible');
        // Wait a frame so layout settles, then check overflow inside this section only
        requestAnimationFrame(() => updateOverflowBorders(target));
      }

      obs.unobserve(target);
    });
  }, {
    root: null,
    rootMargin: '100px',
    threshold: 0.1
  });

  [...lazyImages, ...lazySections, ...lazyIframes].forEach(el => observer.observe(el));

  // Re-check on resize (throttled to rAF)
  let resizeScheduled = false;
  window.addEventListener('resize', () => {
    if (resizeScheduled) return;
    resizeScheduled = true;
    requestAnimationFrame(() => {
      resizeScheduled = false;
      updateOverflowBorders();
    });
  });

  // Also re-check once all blocking resources are done
  window.addEventListener('load', () => updateOverflowBorders());
});

// Tabs: scope per wrapper (desktop + mobile act independently)
document.addEventListener('click', function (event) {
  const tab = event.target.closest('.tab-item');
  if (!tab) return;

  const wrapper = tab.closest('.tabs-wrapper');
  if (!wrapper) return;

  const tabsList = wrapper.querySelectorAll('.tab-item');
  const tabsInfoContents = wrapper.querySelectorAll('.info-content');
  const tabIcons = wrapper.querySelectorAll('.tab-icon');
  const tabName = tab.getAttribute('data-tab');
  const matchingContent = wrapper.querySelector(`.info-content[data-tab="${tabName}"]`);
  const tabIcon = tab.querySelector('.tab-icon');

  function activate() {
    tabsList.forEach(item => item.classList.remove('active'));
    tabIcons.forEach(icon => (icon.textContent = '+'));
    tabsInfoContents.forEach(content => content.classList.remove('active'));
    tab.classList.add('active');

    if (matchingContent) matchingContent.classList.add('active');
    if (tabIcon) tabIcon.textContent = '-';
  }

  if (tab.classList.contains('active') && tab.dataset.platform !== 'desktop') {
    tab.classList.remove('active');
    tabsInfoContents.forEach(content => content.classList.remove('active'));
    tabIcons.forEach(icon => (icon.textContent = '+'));
  } else {
    activate();
  }
});

const mobileTabs = document.querySelectorAll('.tabs-wrapper.mobile .tab-item, .tabs-wrapper.shared .tab-item[data-platform="mobile"]');

mobileTabs.forEach(tab => {
    tab.addEventListener('click', () => {
        requestAnimationFrame(() => {
            requestAnimationFrame(() => {
                tab.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            });
        });
    })
});

const mobileShowMoreTabButtons = document.querySelectorAll('.show-more-btn');

if (mobileShowMoreTabButtons) {
    mobileShowMoreTabButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (button.textContent.trim() === window.translations.showMore) {
                button.textContent = window.translations.showLess;
            } else {
                button.textContent = window.translations.showMore;
            }
            const tabContent = button.closest('.info-content')?.querySelector('.tab-content-wrap');
            if (!tabContent) return;
            tabContent.classList.toggle('full-height');
        })
    });
}


const payLaterTabs = document.querySelectorAll('.pay-later-tab');
const payLaterContents = document.querySelectorAll('.pay-later-tab-content');

payLaterTabs.forEach(payLaterTab => {
    payLaterTab.addEventListener('click', () => {
        payLaterTabs.forEach(t => t.classList.remove('pay-later-active'));
        payLaterContents.forEach(c => c.classList.remove('pay-later-active'));
        const target = document.querySelectorAll(`[data-rr-pay-later-tab="${payLaterTab.dataset.rrPayLaterTab}"]`);
        target.forEach(t => { t.classList.add('pay-later-active')});
    });
});

    function updatePayLaterTab(clickedTab) {
        const container = clickedTab.closest('.rr-pay-later-tab-update-04-03-2025');
 
        if (!container) return;
 
        const tabs = container.querySelectorAll('.pay-later-tab');
        const contents = container.querySelectorAll('.pay-later-tab-content');
 
        tabs.forEach(tab => tab.classList.remove('pay-later-active'));
        contents.forEach(content => content.classList.remove('pay-later-active'));
 
        clickedTab.classList.add('pay-later-active');
 
        const targetId = clickedTab.getAttribute('data-rr-pay-later-tab');
        const target = container.querySelector(`[data-rr-pay-later-tab="${targetId}"].pay-later-tab-content`);
 
        if (target) {
            target.classList.add('pay-later-active');
        }
    }

document.querySelectorAll('.nav-link-a, .mini-garna[data-tab]').forEach(link => {
    if (link.matches('.mini-garna')) {
        link.addEventListener('keydown', event => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                link.click();
            }
        });
    }

    link.addEventListener('click', () => {

        if (!link.dataset.tab) {
        } else {

            tabSection.scrollIntoView({ behavior: 'smooth' });

            const tabData = link.dataset.tab;
            const targetElement = document.querySelectorAll('.pdp-tabs-v3 .' + tabData);
            const infoContents = document.querySelectorAll('.pdp-tabs-v3 .info-content');

            if (targetElement) {
                tabsList.forEach(item => item.classList.remove('active'));
                tabIcons.forEach(icon => (icon.textContent = '+'));
                tabsList.forEach(item => {
                    if(item.dataset.tab === tabData) {
                        item.classList.add('active');
                    }
                });
                tabIcons.forEach(icon => {
                    if(icon.parentElement.dataset.tab === tabData) {    
                        icon.textContent = '-';
                    }
                });
                infoContents.forEach(content => content.classList.remove('active'));
                targetElement.forEach(element => element.classList.add('active'));
            }
        }
        
        if (link.matches('.nav-link-a')) {
            navLinksWrapper.classList.add('active');
            hamburgerIcon.forEach(icon => {icon.classList.toggle('active')});
        }
    });
});

/*
document.querySelectorAll('.popup-buttons-container button').forEach(button => {
    button.addEventListener('click', () => {
        tabSection.scrollIntoView({ behavior: 'smooth' });
        const tabData = button.getAttribute('data-tab');
        const targetElement = document.getElementById(tabData);
        const infoContents = document.querySelectorAll('.pdp-tabs-v3 .info-content');

        if (tabData && targetElement) {
            tabsList.forEach(item => item.classList.remove('active'));
            tabIcons.forEach(icon => (icon.textContent = '+'));
            tabsList.forEach(item => {
                if(item.dataset.tab === tabData) {
                    item.classList.add('active');
                }
            });
            tabIcons.forEach(icon => {
                if(icon.parentElement.dataset.tab === tabData) {    
                    icon.textContent = '-';
                }
            });
            targetElement.classList.add('active');
        }
    })
});*/

document.querySelectorAll('.popup-buttons-container a').forEach(a => {
    a.addEventListener('click', () => {
        const tabData = a.getAttribute('data-tab');

        if (tabData) {
            tabSection.scrollIntoView({ behavior: 'smooth' });
        }
        
        const targetElement = document.getElementById(tabData);
        const infoContents = document.querySelectorAll('.pdp-tabs-v3 .info-content');
        if (tabData && targetElement) {
            tabsList.forEach(item => item.classList.remove('active'));
            tabIcons.forEach(icon => (icon.textContent = '+'));
            tabsList.forEach(item => {
                if(item.dataset.tab === tabData) {
                    item.classList.add('active');
                }
            });
            tabIcons.forEach(icon => {
                if(icon.parentElement.dataset.tab === tabData) {    
                    icon.textContent = '-';
                }
            });
            infoContents.forEach(content => content.classList.remove('active'));
            infoContents.forEach(content => {
                if (content.dataset.tab === tabData) {
                    content.classList.add('active');
                }
            });
            targetElement.classList.add('active');
        }
    })
});

const faqQuestions = document.querySelectorAll('.faq-questions .question');
const faqAnswers = document.querySelectorAll('.faq-answers .answer');

faqQuestions.forEach(question => {
    question.addEventListener('click', () => {
        const handle = question.getAttribute('data-handle');

        faqQuestions.forEach(q => {
            q.classList.remove('active');
        });

        question.classList.add('active');

        faqAnswers.forEach(answer => {
            if (answer.getAttribute('data-handle') === handle) {
                answer.classList.add('active');
            } else {
                answer.classList.remove('active');
            }
        });
    });
});

readMoreBtns.forEach(btn => {
    btn.addEventListener('click', () => {
        const btnTabData = btn.dataset.tab;

        if (window.innerWidth > tabletBreakPoint) {
            var matchingTab = document.querySelector(`.tabs-wrapper.desktop .tab-item[data-tab="${btnTabData}"]`);
            var scrollToContainer = tabSection;
        } else {
            var matchingTab = document.querySelector(`.tabs-wrapper.mobile .tab-item[data-tab="${btnTabData}"]`);
            var scrollToContainer = matchingTab;
        }
        scrollToContainer.scrollIntoView({ behavior: 'smooth' });
        matchingTab.click();
    });
});

// IGNORE 2ND H5 TAG AND ALL CONTENT AFTER THAT
document.addEventListener('DOMContentLoaded', () => {
    const descContainer = document.querySelector('#description .tab-content-wrap');
    if (!descContainer) return;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = descContainer.innerHTML;

    const children = [...tempDiv.childNodes].filter(n => n.nodeType === 1 || n.nodeType === 3);

    const allH5 = tempDiv.querySelectorAll('h5');

    // CASE 1: No <h5> at all → show everything
    if (allH5.length === 0) {
        return;
    }

    // Identify the first meaningful element
    const firstMeaningful = children.find(n => n.textContent.trim().length > 0);
    const isFirstH5 = firstMeaningful && firstMeaningful.tagName === 'H5';

    let output = '';

    // CASE 2: FIRST element is <h5> → show everything until the NEXT <h5>
    if (isFirstH5) {
        const firstH5 = allH5[0];
        const secondH5 = allH5[1] || null;

        let capture = false;

        for (const node of children) {

            // When we reach the first <h5>, start capturing following nodes
            if (node === firstH5) {
                capture = true;
                continue; // Don't include the H5 itself
            }

            // Stop when we hit the second H5
            if (node === secondH5) {
                break;
            }

            if (capture) {
                output += node.outerHTML || node.textContent;
            }
        }

        descContainer.innerHTML = output.trim();
        return;
    }

    // CASE 3: FIRST element is NOT <h5> → show everything BEFORE the first <h5>
    const firstH5 = allH5[0];

    for (const node of children) {
        if (node === firstH5) break;
        output += node.outerHTML || node.textContent;
    }

    descContainer.innerHTML = output.trim();
});


//Overlay Gallery
const mainImageList = document.querySelectorAll('.main-image li');
const thumbnailContainers = document.querySelectorAll('.thumbnail-images');
const activeThumbnails = document.querySelector('.thumbnail-images li.active');
const thumbnailButtons = document.querySelectorAll('.thumbnail-nav');

function openGallery(imageId) {
    const galleryOverlay = document.querySelector('.gallery-overlay');
    galleryOverlay.classList.toggle('active');
    document.body.classList.toggle('modal-open');

    if (imageId) {
        const activeImage = document.querySelectorAll(`li[data-full="${imageId}"]`);
        const thumbnailImageList = document.querySelectorAll('.thumbnail-images li');

        mainImageList.forEach(image => { image.classList.remove('active'); });
        thumbnailImageList.forEach(image => { image.classList.remove('active'); });

        activeImage.forEach(element => {
           element.classList.add('active');
        });
        ensureActiveOverlayThumbVisible();
    }
};

function updateAcvitveImage(imageId) {
    const mainImageList = document.querySelectorAll('.main-image li');
    const targetLis = document.querySelectorAll(`li[data-full="${imageId}"]`);
    const thumbnailImageList = document.querySelectorAll('.thumbnail-images li');

    mainImageList.forEach(li => li.classList.remove('active'));
    thumbnailImageList.forEach(li => li.classList.remove('active'));

    targetLis.forEach(li => li.classList.add('active'));
}

// Helper to keep the active thumbnail in view
function ensureActiveOverlayThumbVisible() {
    thumbnailContainers.forEach(container => {
        const active = container.querySelector('li.active');
        if (!active) return;

        const liLeft = active.offsetLeft;
        const liWidth = active.offsetWidth;
        const containerWidth = container.clientWidth;

        const targetScrollLeft = liLeft - (containerWidth - liWidth) / 2;

        container.scrollTo({
            left: targetScrollLeft,
            behavior: 'smooth'
        });
    });
}

// Gallery toggle
document.addEventListener('click', event => {
    const toggler = event.target.closest('.gallery-toggle, .magnifying-glass-solid');
    if (!toggler) return;
    openGallery(toggler.dataset.full);
});

// Thumbnail click
document.addEventListener('click', event => {
    const thumbnail = event.target.closest('.thumbnail-images li');

    if (!thumbnail) return;

    thumbnail
        .closest('.thumbnail-images')
        ?.querySelectorAll('li')
        .forEach(item => {
            item.classList.remove('active');
        });

    updateAcvitveImage(thumbnail.dataset.full);
});

// Overlay Buttons
document.addEventListener('click', event => {
    const button = event.target.closest('.thumbnail-nav');

    if (!button) return;

    const direction = parseInt(button.value, 10);
    const wrapper = button.closest('.thumbnail-wrapper');

    if (!wrapper) return;

    const container = wrapper.querySelector('.thumbnail-images');
    if (!container) return;

    const allThumbs = container.querySelectorAll('li');
    const activeThumb = container.querySelector('li.active');

    if (!allThumbs.length || !activeThumb) return;

    let target;

    if (direction === -1) {
        target = activeThumb.nextElementSibling || allThumbs[0];
    } else if (direction === 1) {
        target = activeThumb.previousElementSibling || allThumbs[allThumbs.length - 1];
    }

    if (!target) return;

    activeThumb.classList.remove('active');
    target.classList.add('active');

    const scrollLeft = target.offsetLeft - (container.clientWidth / 2) + (target.offsetWidth / 2);

    container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
    });

    updateAcvitveImage(target.dataset.full);
});

document.addEventListener( 'DOMContentLoaded', detectScrollContainerOverflow);
window.addEventListener( 'resize', detectScrollContainerOverflow);

//Adds active class to the right button if a scroll container overflows
function detectScrollContainerOverflow() {
    document.querySelectorAll('.scroller-wrapper').forEach(sw => {
        const rightBtn = sw.querySelector('.scroll-button.right');
        const scrollContainer = sw.querySelector('.scroll-container');
        const clientWidth = scrollContainer.clientWidth;
        const scrollWidth = scrollContainer.scrollWidth;

        if (scrollWidth > clientWidth) {
            rightBtn.classList.add('active');
        }
    });
}

//Arrow left and right for anything that scrolls
document.querySelectorAll('.scroller-wrapper').forEach(sw => {
    const btns = sw.querySelectorAll('.scroll-button');
    const leftBtn = sw.querySelector('.scroll-button.left');
    const rightBtn = sw.querySelector('.scroll-button.right');

    const scrollContainer = sw.querySelector('.scroll-container');
    const scrollItems = sw.querySelectorAll('.scroll-container li');

    const scrollAmount = scrollItems[0];
    const clientWidth = scrollContainer.clientWidth;
    const scrollWidth = scrollContainer.scrollWidth;

    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            
            let direction = 0;
            let scrollLeft = 0;

            if (btn.classList.contains('right')) {
                direction = scrollAmount.offsetWidth + 10;
            } else {
                direction = 0 - scrollAmount.offsetWidth - 10;
            }

            scrollContainer.scrollBy({ left: direction /*, behaviour: 'smooth' */ });

            scrollLeft = scrollContainer.scrollLeft;

            const atStart = scrollLeft <= 0;
            const atEnd = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;

            leftBtn.classList.toggle('active', !atStart);
            rightBtn.classList.toggle('active', !atEnd);
/*
            setTimeout(() => {
                scrollLeft = scrollContainer.scrollLeft;

                const atStart = scrollLeft <= 0;
                const atEnd = Math.ceil(scrollLeft + clientWidth) >= scrollWidth;

                leftBtn.classList.toggle('active', !atStart);
                rightBtn.classList.toggle('active', !atEnd);
            }, 300);
*/
        });
    });
});

document.querySelectorAll('.accordion-toggle').forEach(header => {
    header.addEventListener("click", () => {
        const container = header.closest(".accordion");
        container.classList.toggle("open");
    });
});